<template>
  <div class="h-100 d-flex flex-column">
    <div class="sidebar-top">
      <div class="sidebar-item">
        <export-btn></export-btn>
      </div>
      <div class="sidebar-item">
        <job-queued></job-queued>
      </div>
      <div class="sidebar-item feedback-item feedback-item-bg d-none">
        <feedback></feedback>
      </div>
    </div>
    <div class="sidebar-right-bot">
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import ExportBtn from "../Elements/ExportBtn.vue";
import ContinueWith from "../Elements/ContinueWith.vue";
import JobQueued from "../Elements/JobQueued.vue";
import currentJob from "../../mixins/current_job.mixin";
import QueuePlaceInQueue from "../Elements/QueueState/QueuePlaceInQueue.vue";
import QueueGeneric from "../Elements/QueueState/QueueGeneric.vue";
import QueueProcessing from "../Elements/QueueState/QueueProcessing.vue";
import QueueComplete from "../Elements/QueueState/QueueComplete.vue";
import QueueFailed from "../Elements/QueueState/QueueFailed.vue";
import QueueFull from "../Elements/QueueState/QueueFull.vue";
import QueuePrepare from "../Elements/QueueState/QueuePrepare.vue";
import DownloadBtn from "../Elements/DownloadBtn.vue";
import ShareBtn from "../Elements/ShareBtn.vue";
import DeleteBtn from "../Elements/DeleteBtn.vue";
import ChangeOptionsBtn from "../Elements/ChangeOptionsBtn.vue";
import StartOverBtn from "../Elements/StartOverBtn.vue";
import Notify from "../Elements/Notify.vue";
import Feedback from "../Elements/Feedback.vue";
import user from "../../mixins/user.mixin";
import {satGlobals} from "../../../../../../sat/helper/sat-globals";
import CurrentTask from "../Elements/CurrentTask.vue";
import Reconvert from "../../util/Reconvert";
import {EventBus} from "../../events/event.bus";
import {EVENT_JOB_FAIL, EVENT_JOB_INIT_SUCCESS} from "../../events/job.events";
import JobManager from "../../manager/JobManager";
import ApiManager from "../../manager/ApiManager";
import FileManager from "../../../aicreatorstudio/manager/FileManager";
import {decodeBase64ToImageUrl, encodeImageToBase64} from "../../../../../../helper/base64";
import {JOB_STATE_COMPLETE, JOB_STATE_FAILED, JOB_STATE_INCOMPLETE} from "../../const/job.const";

export default {
  name: "SidebarRightExport",
  props: {},
  components: {
    CurrentTask,
    Feedback,
    StartOverBtn,
    Notify,
    ChangeOptionsBtn,
    DeleteBtn,
    ShareBtn,
    DownloadBtn,
    QueuePrepare,
    QueueFull,
    QueueFailed,
    QueueComplete,
    QueueProcessing,
    QueueGeneric,
    QueuePlaceInQueue,
    JobQueued,
    ExportBtn,
    ContinueWith,
  },
  mixins: [
    store,
    currentJob,
    user
  ],
  data() {
    return {
      adId: satGlobals.getProjectName().toLowerCase() + '_post_2',
      outputSource: ''
    };
  },
  mounted: function () {
  },
  created: function () {
    if (satGlobals.getProjectName().toLowerCase() === 'img2go') {
      this.adId = 'td-top-mpu-1';
    }
    if (satGlobals.getProjectName().toLowerCase() === 'online-convert') {
      this.adId = 'post_conversion_300x250';
    }
  },
  methods: {
    startExport() {
      EventBus.$emit('export', {});
    },
    clearMask() {
      EventBus.$emit('clearMask', {});
    },
    async sendToApi() {
      let apiJob = await ApiManager.create({operation: 'aimagiceditor'});
      let prompt = FileManager.fromText('prompt.txt', 'prompt', this.resultPage.settings.prompt);
      await ApiManager.uploadBase64(apiJob, prompt);

      let mask = FileManager.fromImage('mask.png', 'mask_image', this.resultPage.mask);
      await ApiManager.uploadBase64(apiJob, mask);

      let baseImage = FileManager.fromImage('base_image.png', 'base_image', this.resultPage.image);
      await ApiManager.uploadBase64(apiJob, baseImage);

      await ApiManager.start(apiJob, {
        target: 'image-to-image',
        category: 'operation',
        options: {
          aspect_ratio: '1:1',
          style: 'realisticVisionV51_v51VAE-inpainting.safetensors',
          allow_multiple_outputs: true,
          inpainting_area: 'only_masked',
          cfg_scale: 7,
          height: 1024,
          width: 1024,
          num_inference_steps: 20,
          batch_size: 1,
          batch_count: 1,
        }
      });

      apiJob =  await ApiManager.get(apiJob);
      await this.waitUntilComplete(apiJob);

      let finalJob =  await ApiManager.get(apiJob);
      this.outputSource = finalJob.output[0].uri;
      this.resultPage.outputImage = finalJob.output[0].uri;

    },
    async waitUntilComplete(job, incomplete = 0) {
      return new Promise((resolve, reject) => {

        async function _waitUntilComplete(job, incomplete = 0) {
          let apiJob = await ApiManager.get(job);
          if (null === apiJob) {
            resolve();

            return;
          }

          if (apiJob.status.code === JOB_STATE_FAILED) {
            EventBus.$emit(EVENT_JOB_FAIL, {});

            resolve();
            return;
          }

          if (apiJob.status.code === JOB_STATE_COMPLETE) {
            resolve();
            return;
          }

          if (apiJob.status.code === JOB_STATE_INCOMPLETE) {
            if (incomplete > 60) {
              job.state = JOB_STATE_FAILED;

              resolve();
              return;
            }

            setTimeout(() => {
              _waitUntilComplete(job, ++incomplete);
            }, 2100);
            return;
          }

          setTimeout(() => {
            _waitUntilComplete(job);
          }, 2100);

          return;
        }

        _waitUntilComplete(job, incomplete);
      })
    }
  },
  computed: {
    reconvertLinks() {
      return Reconvert.getReconvertList(this.currentJob);
    }
  }
};
</script>
<style lang="scss" scoped>
.sidebar-item {
  padding: 20px 20px;
  border-bottom: 1px solid #CBCBCB;
  width: 100%;
  background: white;
  color: black;

  .dark-mode & {
    background:#272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}

.btn-box {
  min-height: 105px;
  height: 105px;
}
.sidebar-right-bot-ad {
  //border-top: 1px solid #CBCBCB;
  padding: 20px;
}

.mask-image {
  border: 1px solid red;
  margin: 3px;
}
</style>
